import ResponsiveImage from './ResponsiveImage'

export default function PageHero({ index, eyebrow, title, italic, description, image, tags = ['Ingeniería', 'Ejecución', 'Seguridad'] }) {
  return (
    <section className="page-hero texture-grid">
      <div className="page-hero-copy">
        <span className="page-index" data-hero>{index}</span>
        <p className="eyebrow" data-hero>{eyebrow}</p>
        <h1 data-hero>{title}<br />{' '}<em>{italic}</em></h1>
        <p className="page-lede" data-hero>{description}</p>
        <div className="page-hero-tags" data-hero>
          {tags.map((tag) => <span key={tag}>{tag}</span>)}
        </div>
      </div>
      <div className="page-hero-media" data-hero>
        <ResponsiveImage name={image} alt="Equipo CRS trabajando en cimentación profunda" eager />
        <span className="image-tag">CRS / Obra real</span>
      </div>
    </section>
  )
}
